import type { NegociacaoDocumentoUiItem } from '../types/negociacaoDetailTypes';

type DocumentosViewMode = 'FLAT' | 'SECTIONS' | 'EMPTY';

interface DocumentosSectionsView {
  modo: DocumentosViewMode;
  acordoItems: NegociacaoDocumentoUiItem[];
  outrosItems: NegociacaoDocumentoUiItem[];
  mostrarOutros: boolean;
}

export function montarSecoesDocumentos(params: {
  documentos: NegociacaoDocumentoUiItem[];
  acordoIds: readonly string[];
  etapaContratoConfigurada: boolean;
  temAssinaturaAtiva?: boolean;
}): DocumentosSectionsView {
  const { documentos, acordoIds, etapaContratoConfigurada, temAssinaturaAtiva = false } = params;

  const idsAcordo = new Set(acordoIds);
  const acordoItems = documentos.filter((doc) => idsAcordo.has(doc.id));
  const outrosItems = documentos.filter((doc) => !idsAcordo.has(doc.id));

  if (!etapaContratoConfigurada && !temAssinaturaAtiva) {
    return {
      modo: documentos.length === 0 ? 'EMPTY' : 'FLAT',
      acordoItems: [],
      outrosItems: documentos,
      mostrarOutros: false,
    };
  }

  return {
    modo: 'SECTIONS',
    acordoItems,
    outrosItems,
    mostrarOutros: outrosItems.length > 0,
  };
}
